export interface AiChatPrompt {
  id: string;
  label: string;
}

export const AI_CHAT_PROMPTS: readonly AiChatPrompt[] = [
  { id: "catch_me_up", label: "Catch me up" },
  { id: "whats_weighing", label: "What's weighing on {teen}?" },
  { id: "where_to_start", label: "Where should I start today?" },
  { id: "shared_recently", label: "What have they shared recently?" },
] as const;

export function formatPromptLabel(label: string, teenName: string): string {
  const name = teenName.trim().length > 0 ? teenName.trim() : "them";
  return label.replace(/\{teen\}/g, name);
}
